export const ADMIN_SHELL_DESKTOP_MIN_WIDTH = 1200;
export const ADMIN_SHELL_MOBILE_MAX_WIDTH = 767;

/**
 * Keep tablet portrait layouts compact without turning the navigation into a
 * modal drawer. The compact mode retains the tappable collapsed rail, while
 * phones use the overlay drawer and wide desktop screens use the full sidebar.
 */
export function getAdminShellViewportMode(width) {
  if (width <= ADMIN_SHELL_MOBILE_MAX_WIDTH) return 'mobile';
  if (width < ADMIN_SHELL_DESKTOP_MIN_WIDTH) return 'compact';
  return 'desktop';
}

export function sidebarStartsOpenForWidth(width) {
  return getAdminShellViewportMode(width) === 'desktop';
}
